export const MAP_STYLE = {
	sold: {
		fillColor: "#C7C7C7",
		cursor: "default",
		zIndex: 100,
	},
	available: {
		fillColor: "#47baa3",
		cursor: "pointer",
		zIndex: 100,
	},
	unavailable: {
		fillColor: "#E7E7E7",
		cursor: "default",
		zIndex: 100,
	},
	model: {
		fillColor: "#ff9500",
		cursor: "pointer",
		zIndex: 100,
	},
	quickmove: {
		fillColor: "#00a7ff",
		cursor: "pointer",
		zIndex: 100,
	},
	hover: {
		fillColor: "#ffffff",
		cursor: "pointer",
		zIndex: 100,
	},
	inactive: {
		fillColor: "#eeeeee",
		cursor: "default",
		zIndex: 0,
	},
} as const;
